import { useQuery } from "@tanstack/react-query";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import firebase from "../../services/firebase";

// Function to fetch menu data from Firestore
const fetchMenuData = async ({ queryKey }) => {
  // queryKey is an array, where the first element is the key of the query function
  const [_, weekNumber] = queryKey;
  const db = getFirestore(firebase);
  const docRef = doc(db, "lunchMenu", weekNumber.toString());
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    throw new Error("Document does not exist");
  }
};

// Custom hook using React Query to fetch menu data for a given week
export function useWeekMenu(weekNumber) {
  return useQuery({
    queryKey: ["menuData", weekNumber],
    queryFn: fetchMenuData,
    // Optionally, you can add configurations here, e.g., refetchInterval, staleTime, etc.
  });
}
